// extracted by mini-css-extract-plugin
module.exports = {"Dragger":"Dragger_Dragger__1AY5Y"};